export default __webpack_public_path__ + "img/WB_RTK.b56b29918742b926cb607a3d5ec71c81.jpg";